<app-header></app-header>
<div fxLayout="row" id="container">
  <div fxFlex="17%">
    <app-sidebar></app-sidebar>
  </div>
  <div
    fxFlex="grow"
    class="main"
    [style.background-color]="isBackground ? '#f0f1f8' : '#fff'"
  >
    <p
      class="warning-label"
      *ngIf="user.totpEnabled && FADetails && FADetails?.provider === 'EMAIL'"
    >
      Two-factor authentication (2FA) is now active on your account. You can use
      email for One-Time Passwords (OTPs) up to
      <span style="font-weight: bold">
        {{ FADetails?.maxAttemptsUsage - FADetails?.emailAttempts }} more
        times.</span
      >
      Go to Settings > Account Security in your account. Find the Two-Factor
      Authentication section and click the “Configure 2FA” link to set up your
      2FA app.
    </p>
    <p
      class="warning-label"
      *ngIf="
        (!FADetails || !user.totpEnabled) &&
        applicationConfig &&
        isFutureDate(applicationConfig)
      "
    >
      To ensure your account's continued security, you must enable Two-Factor
      Authentication (2FA) by the {{ applicationConfig | date }}, deadline.
      Without this activation, your account will be locked. Go to Settings >
      Account Security in your account. Find the Two-Factor Authentication
      section and click the switch/toggle button to enable 2FA.
    </p>
    <p class="warning-label" *ngIf="usedRecoveryCode && user.totpEnabled">
      Your account's Two-Factor Authentication (2FA) is currently in recovery
      mode. To re-establish your 2FA protection, go to Settings > Account
      Security in your account. Find the Two-Factor Authentication section and
      click the "Re-Configure 2FA" link to set up your 2FA app again.
    </p>
    <router-outlet></router-outlet>
  </div>
</div>
